import { formatNewsDate, mapExperiences, mapServices } from "./homePage";
import { API_ENDPOINTS } from "./config";

const SERVICES_API = API_ENDPOINTS.services;

let servicesPageRequest = null;
const serviceDetailRequests = {};

export { mapExperiences };

export const mapServiceDetail = (item) => {
  if (!item) return null;

  return {
    id: item.id,
    title: item.title || "",
    sortTitle: item.sort_title || item.title || "",
    sortDescription: item.sort_description || "",
    description: item.description || "",
    position: item.position,
    icon: item.icon,
    image: item.image,
    descriptionPoints: (item.description_points || []).map((point) => ({
      id: point.id,
      description: point.description,
    })),
    servicePoints: (item.service_points || []).map((point) => ({
      id: point.id,
      title: point.title,
      value: Number(point.value) || 0,
    })),
    faqs: (item.faqs || [])
      .filter((faq) => faq.status !== false)
      .map((faq) => ({
        id: faq.id,
        question: faq.question,
        answer: faq.answer,
      })),
  };
};

export const fetchServicesPage = async () => {
  if (servicesPageRequest) return servicesPageRequest;

  servicesPageRequest = fetch(SERVICES_API)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch services page data (${response.status})`);
      }

      const data = await response.json();

      return {
        services: mapServices(data.data),
        experiences: mapExperiences(data.experiences),
        contact: data.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      servicesPageRequest = null;
      throw error;
    });

  return servicesPageRequest;
};

export const fetchServiceDetail = async (id) => {
  if (serviceDetailRequests[id]) return serviceDetailRequests[id];

  serviceDetailRequests[id] = fetch(`${SERVICES_API}/${id}`)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch service detail (${response.status})`);
      }

      const payload = await response.json();

      return {
        service: mapServiceDetail(payload.data),
        contact: payload.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      delete serviceDetailRequests[id];
      throw error;
    });

  return serviceDetailRequests[id];
};

export { formatNewsDate };
